import React from 'react';
import {numberClass, reduceScores} from '../Common';
import classnames from 'classnames';
import OverflowTooltip from 'components/pure/utils/OverflowTooltip';
import {BarChartIcon} from '@components/icon/BarChartIcon';
import TrendChartContainer from './TrendChartContainer';
import Popper from '@material-ui/core/Popper';
import TableCell from 'components/manager-dashboard/strengths-and-weaknesses/TableCell';
import TableScore from 'components/manager-dashboard/strengths-and-weaknesses/TableScore';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';

export default class TableRow extends React.PureComponent {
  constructor(props) {
    super(props);
    this.barsClick = this.barsClick.bind(this);
    this.onPopoverRequestClose = this.onPopoverRequestClose.bind(this);
    this.state = {
      openPopover: false,
    };
  }

  barsClick(e, item) {
    e.stopPropagation();
    e.preventDefault();
    if (this.props.rowTooltip) {
      if (this.props.rowTooltip(item)) {
        this.setState({
          openPopover: true,
        });
      }
    }
  }

  onPopoverRequestClose() {
    this.setState({
      openPopover: false,
    });
  }

  render() {
    const {item, scores, skillsOrder, hoverIndex, itemLabel, onCreatePlan} = this.props;

    const isRep = itemLabel === 'REP';
    const trendDisplayLabel = isRep ? 'Rep' : 'Team';

    const avg = reduceScores(scores.skillScores);
    const skillScores = skillsOrder.map((skill, i) => {
      return (
        <TableCell
          key={`${item.id}-${skill}`}
          location={this.props.location}
          hovered={hoverIndex === i}
          scores={scores}
          skill={skill}
          item={item}
          onMouseEnter={() => this.props.updateHoverIndex(i)}
          onMouseLeave={() => this.props.updateHoverIndex(null)}
          rowTooltip={this.props.rowTooltip}
          isRep={isRep}
          onCreatePlan={onCreatePlan}
        />
      );
    });
    return (
      <tr>
        <td
          className={classnames(
            'rep-name',
            'freeze-left',
            item.active === false ? 'disabled' : null
          )}
          onClick={() => this.props.nameClick(item)}
          key={`${item.id}-Name`}
          ref={c => (this.popoverAnchor = c)}>
          <OverflowTooltip tooltipText={item.displayName} divKey={'item-' + item.displayName}>
            <div className="rep-name-overflow">{item.displayName}</div>
          </OverflowTooltip>
          {this.props.rowTooltip && (
            <div className={'bars-icon index'} onClick={e => this.barsClick(e, item)}>
              <BarChartIcon tooltip="Over time chart" />
            </div>
          )}
          {this.state.openPopover && (
            <ClickAwayListener onClickAway={this.onPopoverRequestClose}>
              <Popper
                open
                anchorEl={this.popoverAnchor}
                anchorOrigin={{horizontal: 'middle', vertical: 'top'}}
                targetOrigin={{horizontal: 'middle', vertical: 'bottom'}}
                className="skill-popover destyle-popover">
                <div className="tooltip-container">
                  <div className="ev-tooltip">
                    <div className="tooltip-content">
                      <TrendChartContainer
                        chartLabel={`Score Trend for ${trendDisplayLabel}: '${item.displayName}'`}
                        onClose={this.onPopoverRequestClose}
                        startDate={this.props.startDate}
                        endDate={this.props.endDate}
                      />
                    </div>
                  </div>
                </div>
              </Popper>
            </ClickAwayListener>
          )}
        </td>
        {skillScores}
        <td
          className={classnames(
            'score-avg',
            'freeze-right',
            avg == null ? 'not-applicable' : numberClass(avg),
            hoverIndex === -1 ? 'hovered' : null
          )}
          key={`${item.id}-scoreAvg`}
          onMouseEnter={() => this.props.updateHoverIndex(-1)}
          onMouseLeave={() => this.props.updateHoverIndex(null)}>
          <TableScore {...{score: avg}} />
        </td>
        <td
          className="scorecard-count freeze-right"
          onClick={() => this.props.totalsClick(item)}
          key={`${item.id}-scoreCardCount`}>
          <div>{scores.scorecardCount}</div>
        </td>
      </tr>
    );
  }
}

TableRow.displayName = 'SAW-TableRow';
